import React from 'react';
import styles from './Futurecredentialing.module.css';
import software_icon from "../../assets/icons_hero/Software-only-Solution.svg"
import outsource_icon from "../../assets/icons_hero/Fully-Outsourced-Service.svg"
import { Link } from 'react-router-dom';

const Futurecredentialing=()=>{
  return (
<section className={styles.main_container}>
        <div className={styles.container}>
        <header>
            <h2 className={styles.title}>Experience the Future of Credentialing</h2>
            <p className={styles.description}>
                {/* We understand that every healthcare organization has unique needs. That's why we provide white-glove services tailored specifically to your requirements. Whether you need a hands-on approach or a fully managed solution, we offer <strong><em>Two Flexible Solutions</em></strong> to fit your needs. <strong>Contact Us</strong> to find out more. */}
                <Link to="/contact" className={styles["contactus-link"]}>
                  <strong>Contact us</strong>
                </Link>
                {' '}
                to discuss more about how we can best improve your workflow!
            </p>
        </header>

        <div className={styles.grid}>
            <article className={styles.card}>
            <header className={styles.header}>
                <img src={software_icon} alt="Software Icon" className={styles.icon} />
                <h3>Software-Only Solution</h3>
            </header>
            {/* <p className={styles.cardInfo}>
                Gain full control with our cutting-edge credentialing platform. We provide comprehensive training and support, empowering your team to efficiently manage credentialing and compliance processes.
            </p> */}
            <p className={styles.cardInfo}>
                Recommended for organizations who want more control over their data.
            </p>
            <ul className={styles.list}>
                <li>Full control with our cutting-edge credentialing platform.</li>
                <li>Comprehensive training and support included.</li>
                <li>Empower your team to efficiently manage credentialing and compliance processes</li>
            </ul>
            </article>

            <article className={styles.card}>
            <header className={styles.header}>
                <img src={outsource_icon} alt="Outsourced Service Icon" className={styles.icon} />
                <h3>Fully Outsourced Service</h3>
            </header>
            {/* <p className={styles.cardInfo}>
                Let us handle everything for you. Our end-to-end managed credentialing services ensure that you stay compliant, minimize delays, and maximize reimbursements without lifting a finger.
            </p> */}
            <p className={styles.cardInfo}>
                Recommended for hassle free service.
            </p>
            <ul className={styles.list}>
                <li>Complete end-to-end managed credentialing services</li>
                <li>Stay compliant and minimize delays automatically</li>
                <li>Maximize reimbursements without lifting a finger</li>
                <li>We handle everything for you</li>
            </ul>
            </article>
        </div>
        </div>
    </section>
)}

export default Futurecredentialing;